import { AutoCompleteAdvantages } from '@components/AutoComplete/AutoCompleteAdvantages';
import InputRichText from '@components/InputRichText';
import { useOptionsContext } from '@modules/talents/context/options-context';
import { Card } from '@mui/material';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

const DescriptionForm = () => {

    const { data: optionsData } = useOptionsContext();
    const options = useMemo(() => optionsData?.options, [optionsData]);
    const { control } = useFormContext();

    const getPlaceholder = () => {
        if (options?.advantages?.[0]?.children?.[0]?.name) {
            return `Ex: ${options.advantages[0].children[0].name}`;
        }
        return 'Sélectionnez les avantages';
    };
    return (
        <>
            <InputRichText
                label="Missions (minimum 50 caractères)"
                control={control}
                name="description.missions"
                placeholder="Décrivez ici la mission que votre futur(e) salarié(e) aura à réaliser dans le cadre de son emploi. Penser à mettre en évidence les points capitaux pour vous, par exemple, l'autonomie, le management, l'ambiance du salon etc ..."
                required
                defaultValue={undefined}
            />
            <InputRichText
                label="Avantages et atouts"
                control={control}
                name="description.advantages"
                placeholder="Inscrivez ici tous les avantages que vous offrez à vos salariés ainsi que les atouts de votre établissement. Ex : Parking, Salle de repos, Travail en musique, Mutuelle, Tickets resto ..."
                defaultValue={undefined}
            />
            <AutoCompleteAdvantages
                label="Liste des avantages et atouts"
                placeholder={getPlaceholder()}
                groupedOptions={options?.advantages}
                control={control}
                name="description.listAdvantages"
                allowAdd={true}
                rules={{
                    required: 'Veuillez sélectionner au moins un avantage',
                }}
                onChange={val => {
                    // Validate max 6 items
                    if (val?.length > 6) {
                        console.warn('Vous ne pouvez pas sélectionner plus de 6 avantages');
                        return;
                    }
                }}
            />
        </>
    );
};

export default DescriptionForm;
